module.exports = __webpack_public_path__ + "img/8.923a00a8.png";